(function () {
  var data;
  try { data = JSON.parse(document.getElementById('wlm-data').textContent); } catch (e) { return; }
  var root = document.getElementById('meets');
  if (!root) return;
  // Langue de la page (balise <html lang>, posée par Shopify) ; une langue sans textes ici retombe sur le français.
  var LANG = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var TXT = {
    fr: {
      P: ['Photos', 'Toute ta compétition en photos, de l’échauffement à la dernière barre.'],
      R: ['Reel monté', 'Un montage vertical sur la musique de ton choix, prêt à publier.'],
      U: ['Rushes étalonnés', 'Toutes tes vidéos étalonnées, prêtes pour ton propre montage.'],
      from: 'dès ', offered: 'Ce qui est proposé', choose: 'Choisis tes médias', all: 'Tout prendre, pack VIP',
      order: 'Ta commande', note: 'Paiement en ligne. Après le paiement, tu reçois un formulaire pour préparer ta livraison.',
      empty: 'Aucun média choisi pour le moment.', save: 'Tu économises <b>{x}</b> avec ce pack.',
      vipLess: 'Le pack VIP (photos, reel et rushes) coûte {x}, soit {y} de moins.',
      vipMore: 'Pour {x} de plus, le pack VIP ajoute {y}.', and: ' et ', toVip: 'Passer au pack VIP', cta: 'Commander, {x}'
    },
    en: {
      P: ['Photos', 'Your whole meet in photos, from warm-up to your last lift.'],
      R: ['Edited reel', 'A vertical edit set to the music of your choice, ready to post.'],
      U: ['Colour-graded rushes', 'All your videos, colour-graded and ready for your own edit.'],
      from: 'from ', offered: 'What’s on offer', choose: 'Choose your media', all: 'Take it all: VIP pack',
      order: 'Your order', note: 'Pay online. After payment, you get a form so we can prepare your delivery.',
      empty: 'No media selected yet.', save: 'You save <b>{x}</b> with this pack.',
      vipLess: 'The VIP pack (photos, reel and rushes) costs {x}, that is {y} less.',
      vipMore: 'For {x} more, the VIP pack adds {y}.', and: ' and ', toVip: 'Switch to the VIP pack', cta: 'Order for {x}'
    }
  };
  var T = TXT[LANG] || TXT.fr;
  var fill = function (s, x, y) { return s.replace('{x}', x).replace('{y}', y); };
  var OPTS = {
    P: { name: T.P[0], desc: T.P[1] },
    R: { name: T.R[0], desc: T.R[1] },
    U: { name: T.U[0], desc: T.U[1] }
  };
  var ORDER = ['P', 'R', 'U'];
  var eur = LANG === 'fr' ? function (n) { return n + ' €'; } : function (n) { return '€' + n; };
  var labelOf = function (key) { return key.split('').map(function (k) { return OPTS[k].name; }).join(' + '); };
  // Lien direct vers le paiement : on passe la langue pour que la page de paiement s'affiche dans la même langue.
  var localeParam = LANG === 'fr' ? '' : '?locale=' + LANG;

  // Une variante Shopify est rangée selon ce que son nom contient (photos, reel, rushes, VIP).
  function keyOf(t) {
    t = t.toLowerCase();
    if (/vip/.test(t)) return 'PRU';
    var k = '';
    if (/photo/.test(t)) k += 'P';
    if (/r[eé]el/.test(t)) k += 'R';
    if (/rush/.test(t)) k += 'U';
    return k;
  }

  var EVENTS = [];
  data.forEach(function (p) {
    var v = {};
    p.variants.forEach(function (x) {
      var k = keyOf(x.title);
      var price = Math.round(x.price);
      if (k && (!v[k] || price < v[k][1])) v[k] = [x.id, price];
    });
    if (!Object.keys(v).length) return;
    var title = p.title.replace(/^\s*\d{4}\s*[-–—]?\s*/, '');
    var place = '';
    var m = title.match(/\(([^)]+)\)/);
    if (m) { place = m[1].charAt(0).toUpperCase() + m[1].slice(1).toLowerCase(); title = title.replace(m[0], ''); }
    title = title.split(' / ')[0].trim();
    EVENTS.push({ name: title, place: place, url: p.url, v: v });
  });

  function resolve(ev, keys) {
    if (!keys.length) return { total: 0, ids: [], sum: 0, combo: false };
    var key = ORDER.filter(function (k) { return keys.indexOf(k) > -1; }).join('');
    var sum = keys.reduce(function (t, k) { return t + ev.v[k][1]; }, 0);
    if (ev.v[key]) return { total: ev.v[key][1], ids: [ev.v[key][0]], sum: sum, combo: true, key: key };
    return { total: sum, ids: keys.map(function (k) { return ev.v[k][0]; }), sum: sum, combo: false, key: key };
  }

  EVENTS.forEach(function (ev, i) {
    var available = ORDER.filter(function (k) { return ev.v[k]; });
    var from = Math.min.apply(null, Object.keys(ev.v).map(function (k) { return ev.v[k][1]; }));
    var single = available.length === 1;
    var uid = 'm' + i;
    var el = document.createElement('article');
    el.className = 'meet';
    el.innerHTML =
      '<button class="meet__head" aria-expanded="false" aria-controls="' + uid + '-p" id="' + uid + '-h">' +
        '<span class="meet__n">' + String(i + 1).padStart(2, '0') + '</span>' +
        '<span class="meet__title">' + ev.name + (ev.place ? '<span class="meet__place">' + ev.place + '</span>' : '') + '</span>' +
        '<span class="meet__from">' + T.from + eur(from) + '</span>' +
        '<span class="meet__icon" aria-hidden="true"></span>' +
      '</button>' +
      '<div class="meet__panel" id="' + uid + '-p" role="region" aria-labelledby="' + uid + '-h"><div class="meet__inner"><div class="order">' +
        '<fieldset class="opts" style="border:0;padding:0;margin:0;min-width:0">' +
          '<legend class="opts__head">' + (single ? T.offered : T.choose) + '</legend>' +
          available.map(function (k) {
            return '<label class="opt"><input type="checkbox" name="' + uid + '" value="' + k + '"' + (single ? ' checked' : '') + '>' +
              '<span class="opt__box" aria-hidden="true"></span>' +
              '<span><span class="opt__name">' + OPTS[k].name + '</span><span class="opt__desc">' + OPTS[k].desc + '</span></span>' +
              '<span class="opt__price">' + eur(ev.v[k][1]) + '</span></label>';
          }).join('') +
          (available.length === 3 && ev.v.PRU ? '<div class="quick"><button type="button" class="chip" data-all>' + T.all + '</button></div>' : '') +
        '</fieldset>' +
        '<aside class="sum" aria-live="polite">' +
          '<p class="sum__label">' + T.order + '</p><div class="sum__lines"></div><p class="sum__total">' + eur(0) + '</p><p class="sum__save"></p><p class="sum__hint" hidden></p>' +
          '<a class="btn btn--solid sum__cta" href="' + ev.url + '" aria-disabled="true">' + T.choose + '</a>' +
          '<p class="sum__note">' + T.note + '</p>' +
        '</aside>' +
      '</div></div></div>';
    root.appendChild(el);

    var head = el.querySelector('.meet__head');
    var boxes = [].slice.call(el.querySelectorAll('input'));
    var lines = el.querySelector('.sum__lines');
    var totalEl = el.querySelector('.sum__total');
    var saveEl = el.querySelector('.sum__save');
    var hintEl = el.querySelector('.sum__hint');
    var cta = el.querySelector('.sum__cta');
    var shown = 0;

    head.addEventListener('click', function () {
      var open = !el.classList.contains('is-open');
      el.classList.toggle('is-open', open);
      head.setAttribute('aria-expanded', String(open));
    });

    function countTo(target) {
      var from = shown; shown = target;
      totalEl.classList.remove('bump'); void totalEl.offsetWidth;
      if (from !== target) totalEl.classList.add('bump');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { totalEl.textContent = eur(target); return; }
      var t0 = performance.now(), dur = 450;
      (function step(t) {
        var p = Math.min(1, (t - t0) / dur);
        totalEl.textContent = eur(Math.round(from + (target - from) * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    }

    function update() {
      var keys = boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
      var r = resolve(ev, keys);
      hintEl.hidden = true;
      if (!keys.length) {
        lines.innerHTML = '<span class="sum__empty">' + T.empty + '</span>';
        saveEl.textContent = '';
        cta.textContent = T.choose;
        cta.setAttribute('aria-disabled', 'true');
        cta.removeAttribute('href');
        countTo(0);
        return;
      }
      lines.innerHTML = r.combo || keys.length === 1
        ? '<span>' + labelOf(r.key) + '</span>'
        : keys.map(function (k) { return '<span>' + OPTS[k].name + '</span>'; }).join('');
      var saved = r.sum - r.total;
      saveEl.innerHTML = saved > 0 ? fill(T.save, eur(saved)) : '';
      if (ev.v.PRU && r.key !== 'PRU' && ev.v.PRU[1] <= r.total + 20 && keys.length >= 2) {
        var diff = ev.v.PRU[1] - r.total;
        hintEl.hidden = false;
        hintEl.innerHTML = (diff <= 0
          ? fill(T.vipLess, eur(ev.v.PRU[1]), eur(-diff))
          : fill(T.vipMore, eur(diff), ORDER.filter(function (k) { return keys.indexOf(k) < 0; }).map(function (k) { return OPTS[k].name.toLowerCase(); }).join(T.and))) +
          '<button type="button" data-all>' + T.toVip + '</button>';
      }
      cta.textContent = fill(T.cta, eur(r.total));
      cta.removeAttribute('aria-disabled');
      cta.href = '/cart/' + r.ids.map(function (id) { return id + ':1'; }).join(',') + localeParam;
      countTo(r.total);
    }

    boxes.forEach(function (b) { b.addEventListener('change', update); });
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-all]')) { boxes.forEach(function (b) { b.checked = true; }); update(); }
    });
    update();
  });
})();
